import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { makeStyles } from '@material-ui/styles';
import { colors } from '@skyslope/mache';
import { handleKeyDown } from '../common/accessibility';
import { MAX_ZOOM, MIN_ZOOM, MD_MEDIA_QUERY } from '../common/constants';

interface IHeaderProps {
  numberOfDocuments: number;
  currentDocumentIndex: number;
  fileName: string;
  zoom: number;
  zoomIn: () => void;
  zoomOut: () => void;
}

const useStyles = makeStyles({
  zoomWrapper: {
    position: 'absolute',
    right: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '10px',
    marginRight: '40px',
  },
  zoomBtn: {
    display: 'flex',
    height: '24px',
    width: '24px',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${colors.grey[400]}`,
    borderRadius: '20px',
    padding: 0,
    outline: 'none',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    '&:disabled': {
      opacity: 0.4,
    },
  },
  zoomIcon: {
    fontSize: '20px',
    color: colors.grey[800],
  },
  zoomPercent: {
    color: colors.grey[800],
    width: '58px',
  },
});

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const Header = (props: IHeaderProps) => {
  const { numberOfDocuments, currentDocumentIndex, fileName, zoom, zoomIn, zoomOut } = props;
  const classes = useStyles();
  const screenWidthIsLessThanOrEqualToMdBreakpoint = useMediaQuery(MD_MEDIA_QUERY);
  const currentDoc = currentDocumentIndex + 1;

  if (screenWidthIsLessThanOrEqualToMdBreakpoint) return null;

  return (
    <div className="ds--header">
      <span>
        {`Doc ${currentDoc}/${numberOfDocuments}: `}
        <span className={'ds--header--title'}>{fileName}</span>
      </span>
      <div className={classes.zoomWrapper}>
        <button
          type="button"
          arial-label="Zoom Out"
          className={classes.zoomBtn}
          disabled={zoom <= MIN_ZOOM}
          onClick={zoomOut}
          // @ts-expect-error -- what the fuck is this
          onKeyPress={(e) => handleKeyDown(e, handleKeyDown)}
        >
          <RemoveIcon className={classes.zoomIcon} />
        </button>
        <span className={classes.zoomPercent}>{`${zoom * 100}%`}</span>
        <button
          type="button"
          arial-label="Zoom In"
          className={classes.zoomBtn}
          disabled={zoom >= MAX_ZOOM}
          onClick={zoomIn}
          // @ts-expect-error -- what the fuck is this
          onKeyPress={(e) => handleKeyDown(e, handleKeyDown)}
        >
          <AddIcon className={classes.zoomIcon} />
        </button>
      </div>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default Header;
